import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import useApi from './useApi'
import useToast from './useToast'

export default function useContractExport() {
  const { t } = useI18n()
  const { downloadFile } = useApi()
  const { addToast, showError } = useToast()

  const isExporting = ref(false)

  const generateTimestamp = () => {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const seconds = date.getSeconds()

    return `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`
  }

  const generateFilename = () => {
    return `Contrat-${generateTimestamp()}.xlsx`
  }

  const exportContracts = async (endpoint, searchParams) => {
    isExporting.value = true
    addToast(t('home.export.generating'))

    const filename = generateFilename()
    const url = `${endpoint}?${searchParams.toString()}`

    try {
      await downloadFile(url, filename, true)
      addToast(t('home.export.sucess'), 'success')
      isExporting.value = false
    } catch (error) {
      console.error('Error exporting contracts:', error)
      showError(t('document.downloadError'))
      isExporting.value = false
    }
  }

  const canDownloadExport = (roles) => {
    return roles.includes('ROLE_EXPORT_CONTRACTS')
  }

  return {
    isExporting,
    exportContracts,
    canDownloadExport,
    generateFilename,
  }
}
